// Also known as "Shop By Collection".
// HTML is rendered by Liquid (trending-now.liquid).
import { waitForElements } from '../helpers/utils';
import '../../styles/components/_trending-now.scss';
import Splide from '@splidejs/splide';
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../constants/devices.constants';
const carouselOptions = {
    mediaQuery: 'min',
    gap: '24px',
    type: 'slide',
    perPage: 1,
    arrows: false,
    pagination: false,
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 2
        },
        [DESKTOP_WIDTH]: {
            perPage: 4,
            arrows: true
        }
    }
};
export default (() => {
    return {
        init: function () {
            const template = document.getElementById('trending-now-template');
            waitForElements('#trending-now-container')
                .then((els) => {
                const renderEl = els[0];
                if (!template) {
                    console.warn('cannot render Trending Now; template is missing');
                    return;
                }
                renderEl.innerHTML = template.innerHTML;
                const splideEl = renderEl.querySelector('.splide');
                if (splideEl) {
                    new Splide(splideEl, carouselOptions).mount();
                }
            })
                .catch(() => {
                console.warn('cannot render Trending Now; container is missing');
            });
        }
    };
})();
